import { render, staticRenderFns } from "./addAppInPlatformGroup.vue?vue&type=template&id=223cbdae&scoped=true&"
import script from "./addAppInPlatformGroup.vue?vue&type=script&lang=js&"
export * from "./addAppInPlatformGroup.vue?vue&type=script&lang=js&"
import style0 from "./addAppInPlatformGroup.vue?vue&type=style&index=0&id=223cbdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223cbdae",
  null
  
)

export default component.exports